import React from "react";
import { useTheme } from '@mui/material/styles';
import { useForm, FormProvider } from 'react-hook-form';
import { Grid, Typography, Box, Button } from "@mui/material";
import FormInput from "../../../components/form/FormInput";
import { object, string } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login } from "../../../redux/actions/auth";

const loginSchema = object({
  email: string().min(1, 'Email is required').email('Email is invalid'),
  password: string()
    .min(1, 'Password is required')
    .min(8, 'Password must be more than 8 characters')
    .max(32, 'Password must be less than 32 characters'),
  role: string(),
});

function LoginForm() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const defaultValues = {
    email: '',
    password: '',
    role: 'client',
  };

  const methods = useForm({
    resolver: zodResolver(loginSchema),
    defaultValues,
  });

  // ? Submit Handler
  const onSubmitHandler = async (data) => {
    const { isSuper, verified, email } = await dispatch(login(data));
    if (isSuper) {
      navigate('/superadmin');
    } else {
      if (verified) {
        navigate('/dashboard', { state: { showTipNow: true }});
      } else {
        navigate('/verify-email', { state: { email } });
      }
    }
  };

  return (
    <Grid
      justifyContent='center'
      sx={{
        width: { sm: '550px' },
        minHeight: '300px',
        backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1e1e2d',
        borderRadius: '0.625rem',
        padding: { xs: 4, md: '4rem' }
      }}
    >
      <FormProvider {...methods}>
        <Box
          display='flex'
          flexDirection='column'
          component='form'
          noValidate
          autoComplete='off'
          onSubmit={methods.handleSubmit(onSubmitHandler)}
        >
          <Typography sx={{ fontWeight: 800, textAlign: 'center', fontSize: '1.5rem', lineHeight: '1.2' }}>Member Login</Typography>
          <Typography sx={{ mt: 1, mb: 2, fontSize: '0.85rem', fontWeight: 400, lineHeight: '1.3', textAlign: 'center', color: theme.palette.mode === 'light' ? '#aaaaaa' : '#565674' }}>Please sign in with your provider account.</Typography>
          <FormInput
            placeholder='Email'
            type='email'
            name='email'
            required
            sx={{ mb: 2 }}
          />
          <FormInput
            type='password'
            placeholder='Password'
            name='password'
            required
          />
          <Grid container justifyContent='end' sx={{ mt: 1 }}>
            <Link to='/forgot-password' style={{ fontSize: '0.8rem' }}>Forgot Password ?</Link>
          </Grid>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            sx={{ mt: 3, color: '#fff', fontWeight: 600, height: '2.5rem', textTransform: 'none' }}
          >
            Sign In
          </Button>
          <Grid container justifyContent='center'>
            <Typography sx={{ mt: 2, fontSize: '14px', textAlign: 'center' }}><span style={{ color: theme.palette.mode === 'light' ? '#a1a5b7' : '#565674' }}>Not a member yet?</span> <Link to='/signup'>Sign up</Link></Typography>
          </Grid>
        </Box>
      </FormProvider>
    </Grid>
  );
}

export default LoginForm;
